import { createRouter, createWebHashHistory } from "vue-router";
import AppContainer from "@/AppContainer.vue";
import LoginView from "@/views/LoginView.vue";
import AlumnosView from "@/views/AlumnosView.vue";
import store from "../store";
import CotizacionesView from "@/views/CotizacionesView.vue";
import DetallesAlumnoView from "@/views/DetallesAlumnoView.vue";
import ProgramarClasesView from "@/views/ProgramarClasesView.vue";
import CalendarioView from "@/views/CalendarioView.vue";
import DashboardView from "@/views/DashboardView.vue";
import DashboardAlumnosView from "@/views/DashboardAlumnosView.vue";
import DashboardFinancieroView from "@/views/DashboardFinancieroView.vue";
import DashboardCombustibleView from "@/views/DashboardCombustibleView.vue";
import GastosView from "@/views/GastosView.vue";
import SolicitudesGastoView from "@/views/SolicitudesGastoView.vue";
import CombustiblesView from "@/views/CombustiblesView.vue";
import IngresosView from "@/views/IngresosView.vue";
import ReporteIngresosView from "@/views/ReporteIngresosView.vue";
import ReporteGastosView from "@/views/ReporteGastosView.vue";
import ReporteFlujoView from "@/views/ReporteFlujoView.vue";
import RolesView from "@/views/RolesView.vue";
import PaquetesPreciosView from "@/views/PaquetesPreciosView.vue";
import { ITEMS_MENU, puedeEntrar, puedeVerItem } from "@/menu";

const routes = [
  {
    path: "/login",
    component: LoginView,
    name: "login",
  },
  {
    path: "/",
    component: AppContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: "/calendario",
      },
      {
        path: "/alumnos",
        meta: { permiso: "alumnos.ver" },
        component: AlumnosView,
        name: "alumnos",
      },
      {
        path: "/alumnos/:id/detalles",
        name: "detallesAlumno",
        component: DetallesAlumnoView,
        props: true,
        meta: { requiresAuth: true, permiso: "alumnos.ver" },
      },
      {
        path: "/calendario",
        name: "calendario",
        component: CalendarioView,
        meta: { requiresAuth: true, permiso: "calendario.ver" },
      },
      {
        path: "/matriculas/:matriculaId/clases",
        name: "programarClases",
        component: ProgramarClasesView,
        props: true,
        meta: { requiresAuth: true, permiso: "calendario.ver" },
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: DashboardView,
        meta: { requiresAuth: true, permiso: "dashboard.ver" },
      },
      {
        path: "/dashboard/alumnos",
        name: "dashboardAlumnos",
        component: DashboardAlumnosView,
        meta: { requiresAuth: true, permiso: "dashboard.ver" },
      },
      {
        path: "/dashboard/financiero",
        name: "dashboardFinanciero",
        component: DashboardFinancieroView,
        meta: { requiresAuth: true, permiso: "dashboard.ver" },
      },
      {
        path: "/dashboard/combustible",
        name: "dashboardCombustible",
        component: DashboardCombustibleView,
        meta: { requiresAuth: true, permiso: "dashboard.ver" },
      },
      {
        path: "/gastos",
        name: "gastos",
        component: GastosView,
        meta: { requiresAuth: true, permiso: "gastos.gestionar" },
      },
      {
        path: "/gastos/solicitudes",
        name: "solicitudesGasto",
        component: SolicitudesGastoView,
        meta: { requiresAuth: true, permiso: ["solicitudes-gasto.crear", "solicitudes-gasto.aprobar"] },
      },
      {
        path: "/gastos/combustible",
        name: "gastosCombustible",
        component: CombustiblesView,
        meta: { requiresAuth: true, permiso: "gastos.gestionar" },
      },
      {
        path: "/ingresos",
        name: "ingresos",
        component: IngresosView,
        meta: { requiresAuth: true, permiso: "ingresos.gestionar" },
      },
      {
        path: "/reportes/ingresos",
        name: "reporteIngresos",
        component: ReporteIngresosView,
        meta: { requiresAuth: true, permiso: "reportes.ver" },
      },
      {
        path: "/reportes/gastos",
        name: "reporteGastos",
        component: ReporteGastosView,
        meta: { requiresAuth: true, permiso: "reportes.ver" },
      },
      {
        path: "/catalogos/paquetes",
        name: "paquetesPrecios",
        component: PaquetesPreciosView,
        meta: { requiresAuth: true, permiso: "catalogos.gestionar" },
      },
      {
        path: "/seguridad/roles",
        name: "roles",
        component: RolesView,
        meta: { requiresAuth: true, permiso: "roles.gestionar" },
      },
      {
        path: "/reportes/flujo",
        name: "reporteFlujo",
        component: ReporteFlujoView,
        meta: { requiresAuth: true, permiso: "reportes.ver" },
      },
    ],
  },
  {
    path: "/",
    component: AppContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/cotizaciones",
        meta: { permiso: "cotizaciones.gestionar" },
        component: CotizacionesView,
        name: "cotizaciones",
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next("/login");
    } else if (!puedeEntrar(store.state.user.permisos, to)) {
      const inicio = ITEMS_MENU.find((i) => puedeVerItem(store.state.user.permisos, i));
      next(inicio && inicio.to !== to.path ? inicio.to : false);
    } else {
      next();
    }
  } else {
    next(); // Asegúrate de siempre llamar a next()
  }
});

export default router;
